import { Box, Button, Text } from 'grommet'
import React, { useEffect, useState } from 'react'
import { I18n } from 'galarm-config'

const EntityNotFound = ({ entityType, onClose, onUnableToFetch }) => {
  const [secondsRemaining, setSecondsRemaining] = useState(10)

  useEffect(() => {
    const timer = setInterval(() => {
      setSecondsRemaining(prev => {
        if (prev <= 1) {
          clearInterval(timer)
          if (onUnableToFetch) {
            onUnableToFetch()
            onClose()
          } else {
            onClose()
          }
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  return (
    <Box
      flex={true}
      justify="center"
      align="center"
      gap="medium"
      background="textBackgroundColor">
      <Text color="textColor">{I18n.t('entityNotFound', { entityType })}</Text>
      <Text color="textColor">
        {I18n.t('screenWillCloseAutomatically', { seconds: secondsRemaining })}
      </Text>
      <Button label={I18n.t('close')} onClick={onClose} />
    </Box>
  )
}

export default EntityNotFound
